import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import ProjectsPage from './components/ProjectsPage';
import NewsArticleDetail from './components/ProjectDetail/NewsArticle';
import BugReportDetail from './components/ProjectDetail/BugReport';
import ArticleSharingDetail from './components/ProjectDetail/ArticleSharing';
import ConcurrentRecordDetail from './components/ProjectDetail/ConcurrentRecord';
import SkillsPage from './components/SkillsPage';
import CVPage from './components/CVPage';
import './App.scss';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Layout><HomePage /></Layout>} />
      <Route path="/about" element={<Layout><AboutPage /></Layout>} />
      <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
      <Route path="/projects" element={<Layout><ProjectsPage /></Layout>} />
      <Route path="/projects/news-article-analysis" element={<Layout><NewsArticleDetail /></Layout>} />
      <Route path="/projects/article-sharing-platform" element={<Layout><ArticleSharingDetail /></Layout>} />
      <Route path="/projects/bug-report-classifier" element={<Layout><BugReportDetail /></Layout>} />
      <Route path="/projects/concurrent-record-database" element={<Layout><ConcurrentRecordDetail /></Layout>} />
      <Route path="/skills" element={<Layout><SkillsPage /></Layout>} />
      <Route path="/cv" element={<Layout><CVPage /></Layout>} />
    </Routes>
    </>
  );
}

export default App;
